import { render, staticRenderFns } from "./FollowUpModal.vue?vue&type=template&id=1e8787f2&scoped=true"
import script from "./FollowUpModal.vue?vue&type=script&lang=ts"
export * from "./FollowUpModal.vue?vue&type=script&lang=ts"
import style0 from "./FollowUpModal.vue?vue&type=style&index=0&id=1e8787f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8787f2",
  null
  
)

export default component.exports